import shallowEqual from 'fbjs/lib/shallowEqual';

export default shallowEqual;


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/lib/shallowEqual.js
// module id = 811
// module chunks = 0